import { Paper } from "@mui/material";
import { ReactNode } from "react";

interface SimpleCardProps {
  id?: any;
  largura: number | string;
  altura: number | string;
  elevacao?: number;
  variant?: "elevation" | "outlined" | string;
  children: ReactNode;
}

const SimpleCard: React.FC<SimpleCardProps> = (props) => {
  return (
    <div>
      <Paper
        sx={{
          width: props.largura,
          height: props.altura,
        }}
        elevation={props.elevacao ? props.elevacao : 6}
      >
        {props.children}
      </Paper>
    </div>
  );
};

export default SimpleCard;
